import { HOURS_PER_DAY } from '../../constants';
import { isLockedEntry } from './dayDraft';

const total = (rows) => rows.reduce((s, r) => s + (parseFloat(r.heures) || 0), 0);

/* Plafond de la saisie manuelle : une journée ne peut pas dépasser 7h (absences et temps Jira
   compris). Les heures importées depuis Jira peuvent le dépasser ; une journée déjà au-delà reste
   modifiable tant que la saisie ne l'alourdit pas. Renvoie le total refusé, ou null si la saisie
   passe. */
export function manualDayOverflow(existing, toUpsert) {
  const before = total(existing);
  const after = total(existing.filter(isLockedEntry)) + total(toUpsert);
  const over = after > HOURS_PER_DAY + 0.001 && after > before + 0.001;
  return over ? Math.round(after * 100) / 100 : null;
}
